/**
 * What the chat shows that the API does not keep: the answers the app gives itself (the settings card, the
 * pause question) and an answer that could not be made. Flashadz writes the lines about what the owner did
 * (a change applied, a pause, an approval); these live for the session only.
 */
export type LocalItem =
  | { kind: "me"; text: string }
  | { kind: "settings" }
  | { kind: "pause"; on: boolean; done: "yes" | "no" | null }
  | { kind: "error"; text: string };

export interface Local {
  id: string;
  at: number;
  item: LocalItem;
}

const store = new Map<string, Local[]>();
const listeners = new Set<() => void>();
let seq = 0;

export function localItems(goalId: string): Local[] {
  return store.get(goalId) ?? [];
}

export function addLocal(goalId: string, item: LocalItem): string {
  const id = `local-${++seq}`;
  store.set(goalId, [...(store.get(goalId) ?? []), { id, at: Date.now(), item }]);
  for (const l of listeners) l();
  return id;
}

export function updateLocal(goalId: string, id: string, item: LocalItem): void {
  store.set(
    goalId,
    (store.get(goalId) ?? []).map((x) => (x.id === id ? { ...x, item } : x)),
  );
  for (const l of listeners) l();
}

export function onLocal(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
